/* ------------------------------------------------
** 需要引入echats和echatsgl
** 需要引入json文件，world_json.json
<script src="https://unpkg.com/echarts@5.4.3/dist/echarts.min.js"></script>
<script src="https://unpkg.com/echarts-gl@2.0.9/dist/echarts-gl.min.js"></script>
** 3D地球，包含全球所有的国家
** 功能：自动旋转;
** 功能：点击对应区域放大，或者外部按钮激活指定区域放大；
** 功能：只显示指定的国家;
** 代码：
<!-- 地图展示容器 -->
<div id="main" style="height: 600px; width: 100%"></div>

<!-- 测试按钮，点击旋转到指定国家 -->
<div class="btn test" data-map-name="China" data-map-center="107.33956288844428,34.04922476869049">测试旋转到中国</div>
<div class="btn test" data-map-name="United States" data-map-center="-97.0198725134513,38.73543231654688">
    测试旋转到美国</div>
<div class="btn test" data-map-name="Russia" data-map-center="101.89039777913206,61.91980868278606">测试旋转到俄罗斯
</div>
--------------------------------------------------*/



var globeChart = null;
var mapChart = null;
var timeout = null; // 用来保存定时器ID
let countryMapping = {} //国家名称映射表
// 防抖函数
function debounce(func, wait) {
    return function (...args) {
        // 清除上一次的定时器
        if (timeout) {
            clearTimeout(timeout);
        }

        // 设置新的定时器
        timeout = setTimeout(() => {
            func.apply(this, args);  // 执行目标函数
        }, wait);
    };
}

const countriesWithLabels = ["China", "United States", "Russia"]; // 定义需要显示标签的国家
// 生成 regions 数组
const regions = countriesWithLabels.map(country => ({
    name: country,
    label: {
        show: true,  // 始终显示标签
        color: "#ffffff",  // 标签文字颜色
        fontSize: 30, // 标签字体大小
        fontWeight: "bold", // 字体加粗
    },
}));

// 配置并初始化地图图表
function setMapOption(data) {
    // 注册地图数据
    echarts.registerMap("world", data);
    const canvas = document.createElement("canvas");

    // 初始化地图图表
    mapChart = echarts.init(canvas, null, {
        width: 3500,
        height: 2000,
    });

    // 设置地图的具体配置
    mapChart.setOption({
        backgroundColor: "#fff",
        textStyle: {
            fontSize: 20,
        },
        geo: {
            type: "map",  // 设置为地图类型
            map: "world",  // 使用世界地图
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            label: {
                show: false, //是否总是显示标签
                formatter: params => {
                    // 将英文名称替换为中文名称
                    return countryMapping[params.name] || params.name;
                },
            },
            boundingCoords: [
                [-180, 90],
                [180, -90],
            ],  // 设置地图的边界坐标
            itemStyle: {
                borderWidth: 4,
                normal: {
                    borderColor: "rgba(175,184,197,0.5)",
                    areaColor: "#d6dce5",  // 默认区域颜色
                    label: {
                        show: false,
                    },
                },
            },
            emphasis: {
                itemStyle: {
                    areaColor: "#00007a",  // 高亮区域颜色
                    borderColor: "#fff",  // 高亮边界颜色
                },
                label: {
                    color: "#fff"
                }
            },
            regions: regions, // 使用生成的 regions 配置
        },
    });
}

// 配置并初始化球面图表
function setGlobeOption(param) {
    globeChart = echarts.init(document.getElementById("global-map"));

    // 
    globeChart.setOption({
        globe: {
            baseTexture: mapChart,  // 使用地图作为球体纹理
            shading: "color", //三维着色效果：color:不受光明影响；lambert:着重表现光照带来的明暗。'realistic'：真实感渲染。
            realisticMaterial: { //shading为realistic时生效
                roughness: 1,
                metalness: 0.3,
            },
            light: {//shading为realistic时生效
                main: {
                    intensity: 0.5,  // 主光源强度
                    shadow: false,  // 启用阴影
                },
                ambient: {
                    color: "#fff",
                    intensity: 1.3,  // 环境光强度
                },
            },
            // atmosphere:{
            //     show:true,
            // },
            postEffect: { //后期处理特效，可以为画面添加亮光、景深、环境光遮蔽、调色等效果
                enable: false,
                bloom: 10,  // 启用光晕效果
            },
            depthOfField: {
                enable: true,
            },
            viewControl: { //用于鼠标的旋转，缩放等视角控制
                zoomSensitivity:0,// 禁止缩放
                center: [0, 0, 0],  // 设置球体的中心
                alpha: 20,
                beta: 50,
                autoRotate: true,  // 启用自动旋转
                //autoRotateAfterStill: 20, //鼠标静止后自动旋转的时间间隔
                distance: 135,  // 设置视角距离
                autoRotateSpeed: 5,  // 设置旋转速度
            },
        }
    });

    // 添加点击事件，用于激活指定区域
    mapChart.on("click", function (params) {
        // 确保点击的是地图区域
        if (params.componentType === "geo") {
            //console.log("点击的国家:", params);  // 打印点击的国家名称

            // 自动计算区域的中心点（经纬度）
            if (params.event && params.event.offsetX !== undefined && params.event.offsetY !== undefined) {
                const geoCoord = mapChart.convertFromPixel("geo", [params.event.offsetX, params.event.offsetY]);
                //console.log(`计算出的中心点为：(通过点击地图): ${geoCoord}`);  // 打印计算的中心点
                debouncedActivateRegion(params.name, geoCoord);  // 调用防抖版本的激活函数
            } else {
                //console.log("Unable to calculate region coordinates.");
            }
        }
    });
};

// 激活区域函数-并调整视图
function activateRegion(regionName, coords) {
    console.log(`激活区域: ${regionName}，坐标: ${coords}`);
    if (globeChart) {
        globeChart.setOption({
            globe: {
                viewControl: {
                    autoRotate: false,  // 停止自动旋转
                    targetCoord: coords,  // 旋转视图到点击区域的经纬度
                    //distance: 120,  // 放大视角
                    animationDurationUpdate: 1300, //过渡动画时长
                },
            },
        });
    }

    // 高亮点击的区域
    mapChart.setOption({
        geo: {
            regions: [
                {
                    name: regionName,
                    label: {
                        show: true,
                        color: "#fff",
                    },
                    itemStyle: {
                        areaColor: "#00007a",  // 设置高亮颜色
                    },
                },
            ],
        },
    });
}

// 重置球体为原始状态
function resetRegion() {
    //console.log(`执行了延时任务`)
    globeChart.setOption({
        globe: {
            viewControl: {
                autoRotate: true,  // 继续自动旋转
                //distance: 200,  // 还原[缩小]视角
            }
        }
    }),
        mapChart.setOption({
            geo: {
                regions: regions
            },
        });
}

// 防抖后的activateRegion函数
const debouncedActivateRegion = debounce(function (regionName, coords) {
    activateRegion(regionName, coords);  // 调用原始的激活函数
}, 300);  // 防抖时间 300 毫秒
// 防抖后的resetRegion函数
const debouncedResetRegion = debounce(function () {
    resetRegion()
}, 300);

// 初始化地图和球体图表
// 初始化时加载地图和数据
$(function () {
    if ($("#global-map").length > 0) {
        // 加载中英文国家映射表
        fetch("/static/cn/js/country_mapping.json")
        .then(response => response.json())
        .then(data => {
            countryMapping = data;
        });
        // 加载地图数据
        fetch("/static/cn/js/world_json.json")
            .then(response => response.json())
            .then(data => {
                setMapOption(data);  // 设置地图配置
                setGlobeOption(data);  // 设置球面图配置
            });
    };

    // 鼠标激活事件
    $(".solutions-list .item,.solution-filter").on("mouseover", function () {
        const name = $(this).attr("data-nation");  // 获取按钮中的国家名称
        let center;
        if ($(this).data("center")) {
            center = $(this).attr("data-center").split(",").map(function (item) {
                return parseFloat(item);
            })
        };  // 获取国家中心点，优先使用按钮数据中的经纬度

        // 使用防抖函数调用激活区域
        console.log(`获取到的按钮中的国家信息为：`,name,center);
        debouncedActivateRegion(name, center);
    });

    //鼠标离开事件
    $(".solutions-list .item,.solution-filter").on("mouseleave", function () {
        debouncedResetRegion();
    })
});